var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('div',{staticClass:"pl-8 pr-8 col-md-12 ml-sm-auto col-lg-12"},[_c('v-row',[_c('v-col',{attrs:{"cols":"7"}},[_c('Package')],1),_vm._v(" "),_c('v-col',[_c('PiePackage')],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58165a0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Core/PackageMain.vue
// module id = null
// module chunks = 